import { isNil } from 'lodash';

import useIdBasedPagination from '~/hooks/useIdBasedPagination';
import type {
  CatEventItemIdsParams,
  IdsResponseIntCatEventListExtraDataCatEventListExtraData as CatEventListExtraData,
  PageDataResponseCatEventResponseNoneTypeCatEventResponse as CatEventResponse,
} from '~/server_shared/openapi/data-contracts';

const DEFAULT_ROWS_PER_PAGE = 25;

interface UseCatEventsPaginationProps {
  organizationId: number;
  sortByColumn?: string;
  nameSearch?: string | null;
  initialRowsPerPage?: number;
}

export const useCatEventsPagination = ({
  organizationId,
  sortByColumn = '-start_date',
  nameSearch,
  initialRowsPerPage = DEFAULT_ROWS_PER_PAGE,
}: UseCatEventsPaginationProps) => {
  const trimmed = nameSearch?.trim();

  const fetchIdsParams: CatEventItemIdsParams = {
    sort_by: sortByColumn,
    ...(!isNil(trimmed) && trimmed !== '' && { name_search: trimmed }),
  };

  const fetchIdsUrl = `/sysconfig/api/v1/organizations/${organizationId}/cat_events/item_ids`;
  const fetchPageDataUrl = `/sysconfig/api/v1/organizations/${organizationId}/cat_events/items_by_ids`;

  return useIdBasedPagination<number, CatEventListExtraData, CatEventResponse, null>({
    fetchIdsUrl,
    fetchPageDataUrl,
    fetchIdsParams: fetchIdsParams as unknown as Record<string, unknown>,
    initialRowsPerPage,
  });
};
